import React, { useState, useCallback, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import "../styles/NavBar.css";

// --- NEW: Import analytics tools ---
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase"; // Ensure this path is correct

function Navbar() {
  const navRef = useRef(null);
  const location = useLocation();
  const [toggleMenu, setToggleMenu] = useState(false);
  const [navHeight, setNavHeight] = useState(0);

  useEffect(() => {
    if (navRef.current) {
      setNavHeight(navRef.current.offsetHeight);
    }
  }, []);

  const handleMenuToggle = useCallback(() => {
    setToggleMenu((prev) => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    if (toggleMenu) {
      setToggleMenu(false);
    }
  }, [toggleMenu]);

  const scrollWithOffset = useCallback((el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -navHeight; 
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  }, [navHeight]);

  // Effect for handling scroll on navigation (omitted for brevity in explanation, but included in full code)
  useEffect(() => {
    if (location.hash && navHeight > 0) {
      let attempts = 0;
      const maxAttempts = 20;
      const checkForElement = setInterval(() => {
        const element = document.getElementById(location.hash.slice(1));
        if (element) {
          scrollWithOffset(element);
          clearInterval(checkForElement);
        } else {
          attempts++;
          if (attempts > maxAttempts) {
            clearInterval(checkForElement);
            console.warn(`Could not find element with id: ${location.hash}`);
          }
        }
      }, 100);
      return () => clearInterval(checkForElement);
    }
  }, [location.hash, navHeight, scrollWithOffset]);

  // --- NEW: Create a reusable handler for tracking nav clicks ---
  const handleNavClick = useCallback((linkText, linkUrl) => {
    logEvent(analytics, 'navigation_link_click', {
      link_text: linkText,
      link_url: linkUrl,
    });
  }, []);


  return (
    <nav className="local-navbar-container" ref={navRef}>
      <div id="menu-icon">
        <input
          type="checkbox"
          id="check-icon"
          hidden
          checked={toggleMenu}
          onChange={handleMenuToggle}
        />
        <label className="icon-menu" htmlFor="check-icon">
          <div className="bar bar--1"></div>
          <div className="bar bar--2"></div>
          <div className="bar bar--3"></div>
        </label>
      </div>

      <ul className={`nav-links ${toggleMenu ? "active" : ""}`}>
        <li>
          {/* --- NEW: Updated onClick handler --- */}
          <HashLink smooth to="/#" scroll={scrollWithOffset} onClick={() => { closeMenu(); handleNavClick('Home', '/#'); }}>
            Home
          </HashLink>
        </li>
        
        <li>
          {/* --- NEW: Updated onClick handler --- */}
          <HashLink smooth to="/#books" scroll={scrollWithOffset} onClick={() => { closeMenu(); handleNavClick('Books', '/#books'); }}>
            Books
          </HashLink>
        </li>
        <li>
          {/* --- NEW: Updated onClick handler --- */}
          <HashLink smooth to="/#about" scroll={scrollWithOffset} onClick={() => { closeMenu(); handleNavClick('About', '/#about'); }}>
            About
          </HashLink>
        </li>
        <li>
          {/* --- NEW: Updated onClick handler --- */}
          <HashLink smooth to="/#newsletter" scroll={scrollWithOffset} onClick={() => { closeMenu(); handleNavClick('Newsletter', '/#newsletter'); }}>
            Newsletter
          </HashLink>
        </li>
        <li>
          {/* --- NEW: Updated onClick handler --- */}
          <Link to="/standing-next-to-a-mountain" onClick={() => { closeMenu(); handleNavClick('Blog', '/standing-next-to-a-mountain'); }}>
            Blog
          </Link>
        </li>
        <li>
          {/* --- NEW: Updated onClick handler --- */}
          <Link to="/speaker" onClick={() => { closeMenu(); handleNavClick('Speaker', '/speaker'); }}>
            Speaker
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;